import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Quote, X } from 'lucide-react';
export function FounderSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <section id="founder" className="py-20 bg-[#F5F0E8]" data-id="element-262">
        <div className="container mx-auto px-4" data-id="element-263">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-264">
            {/* Image Side */}
            <div className="w-full lg:w-5/12" data-id="element-265">
              <div className="relative" data-id="element-266">
                <div className="absolute top-4 left-4 w-full h-full border-2 border-[#D4A843] rounded-lg transform translate-x-4 translate-y-4 z-0" data-id="element-267" />
                <img src="https://cdn.magicpatterns.com/uploads/fLwftKZJHYHmq983KNfD5Y/photo_2026-02-13_11-38-22.jpg" alt="Олена Водолажко — засновниця" className="relative z-10 w-full h-auto rounded-lg object-cover shadow-lg" data-id="element-268" />
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full lg:w-7/12" data-id="element-269">
              <div className="relative" data-id="element-270">
                <Quote className="absolute -top-10 -left-6 text-[#D4A843]/20 w-24 h-24 rotate-180" data-id="element-271" />

                <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-8 relative z-10" data-id="element-272">
                  A Message from the Founder
                </h2>

                <div className="space-y-6 text-lg text-gray-700 relative z-10" data-id="element-273">
                  <p data-id="element-274">Hello everyone!</p>
                  <p data-id="element-275">
                    My name is Olena Vodolazhko. I am a lawyer with extensive
                    experience in regulating the gambling and lottery sector.
                  </p>
                  <p data-id="element-276">
                    I invite you to the FAIR GAMING SPACE, which I created for
                    everyone who wants to make gambling in Ukraine honest and
                    responsible, for those who want to play FAIRLY and
                    responsibly, for those who will HONESTLY talk about
                    addiction and HONESTLY help those who need support in
                    overcoming it.
                  </p>
                  <p data-id="element-277">
                    This is a SPACE for HONEST dialogue, support, education,
                    research, and the development of the gambling industry and
                    everyone who joins it.
                  </p>
                  <p data-id="element-278">Welcome!</p>
                </div>

                <div className="mt-10 mb-8" data-id="element-279">
                  <div className="text-lg text-gray-700" data-id="element-280">With respect,</div>
                  <div className="text-2xl font-serif font-bold text-[#0A5E5C] mt-2" data-id="element-281">
                    Olena Vodolazhko
                  </div>
                  <div className="text-[#D4A843] font-medium mt-1" data-id="element-282">Founder</div>
                </div>

                <Button variant="primary" size="lg" onClick={() => setIsModalOpen(true)} data-id="element-283">
                  Read More
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setIsModalOpen(false)} data-id="element-284">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-285" />

          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-286">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-287">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-288">
                A Message from the Founder
              </h3>
              <button onClick={() => setIsModalOpen(false)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-289">
                <X className="w-5 h-5" data-id="element-290" />
              </button>
            </div>

            <div className="p-6 md:p-8 space-y-5 text-gray-700 leading-relaxed" data-id="element-291">
              <p data-id="element-292">Greetings to all in the Fair Gaming Space!</p>

              <p data-id="element-293">
                Honesty with oneself is, in my view, a prerequisite without
                which it is almost impossible to move forward and grow.
              </p>

              <p data-id="element-294">
                I consider honesty to be the foundation of awareness, freedom,
                wisdom, and harmony — and honesty is always a choice.
              </p>

              <p data-id="element-295">
                Choosing to be honest with yourself and the world can be
                difficult and painful, but it is the only possible path to
                taking responsibility for your life, honestly acknowledging
                mistakes when they exist, correcting them, and moving toward
                wholeness and prosperity.
              </p>

              <p data-id="element-296">
                Honesty is extraordinarily needed in the gambling industry in
                Ukraine today.
              </p>

              <p data-id="element-297">
                My deep professional experience, practical knowledge in gambling
                regulation, various fields of law and psychology, as well as my
                choice to be honest with myself and the world, inspired me to
                create a qualitatively new Space that would unite everyone who
                is ready to join an initiative that promotes honesty and
                transparency in the gambling industry in Ukraine.
              </p>

              <p data-id="element-298">
                Honesty and transparency in this field are fundamentally
                important for the development of a conscious societal attitude
                toward gambling, for fostering a high culture of consumption in
                this area — particularly among children and youth — for
                protecting players' rights, and for providing effective help to
                those who, for whatever reason, have become addicted to
                gambling.
              </p>

              <p data-id="element-299">
                It so happened that in our society today, gambling and
                everything related to it is kept silent, because it tends to
                evoke judgment, shame, negativity, condemnation, anger,
                rejection, and so on. And so it is better to stay silent, avoid
                it, reject it, turn away, and hide.
              </p>

              <p data-id="element-300">
                This can be left as is, but this is precisely the reason that,
                even after legalization, this sector remains misunderstood,
                opaque, even demonized, and sometimes dangerous for those who,
                due to a lack of information and knowledge, and the absence of
                understanding and support, become addicted and are left alone
                with that addiction in shame and guilt.
              </p>

              <p data-id="element-301">
                I am convinced that honesty and the willingness to speak
                honestly about gambling — about what it is and everything
                connected to it — combined with knowledge, education,
                cooperation, mutual understanding, and humanity, will transform
                the gambling industry itself and make it understandable and safe
                for society.
              </p>

              <p data-id="element-302">
                In this Space, everyone who chooses to be honest will be able to
                find their place, their fulfillment, knowledge, useful
                information, tools to protect their rights, methodologies, as
                well as support and understanding.
              </p>

              <p data-id="element-303">
                I invite everyone who shares the values and mission of the Fair
                Gaming Space to cooperate and partner with us.
              </p>

              <p data-id="element-304">
                I also invite to our Space everyone who is interested in
                learning honest information about gambling, about addiction,
                about how to help themselves or their loved ones.
              </p>

              <p data-id="element-305">
                I invite you to learn, research, explore, and support one
                another together, so that the choice to be honest with yourself
                and the world becomes easy and conscious.
              </p>

              <div className="pt-4 border-t border-gray-100" data-id="element-306">
                <p data-id="element-307">With deep respect and best wishes!</p>
                <p className="font-serif font-bold text-[#0A5E5C] text-lg mt-2" data-id="element-308">
                  Olena Vodolazhko
                </p>
                <p className="text-[#D4A843] font-medium" data-id="element-309">Founder, FGS</p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}